import type { ReactNode } from 'react';
import React, { useEffect, useState } from 'react';
import type { AlertColor } from '@mui/material';
import { Box, Snackbar } from '@mui/material';
import CustomAlert from '../Alert/CustomAlert';

interface ToastrProps {
  id: string;
  open?: boolean;
  successOrError?: AlertColor;
  handleClose?: () => void;
  toastrMessage?: string;
  icon?: ReactNode;
  autoHide?: boolean; // New prop to control auto-hiding
  className?: string;
}

const CustomSnackBar: React.FC<ToastrProps> = (props) => {
  const {
    id,
    open,
    successOrError,
    handleClose,
    toastrMessage,
    icon,
    autoHide = true, // Default to true if not provided
    className,
  } = props;

  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open); // Sync with prop changes
  }, [open]);

  const handleSnackbarClose = () => {
    setIsOpen(false); // Close snackbar
    if (handleClose) handleClose();
  };

  return (
    <Box component="div">
      <Snackbar
        id={id}
        open={isOpen}
        autoHideDuration={autoHide ? 4000 : null}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        className={className}
        sx={{
          whiteSpace: 'nowrap',
          width: 'fit-content',
          maxWidth: '900px', // Limit max width
          minWidth: '150px',
          top: '14px !important',
          zIndex: 99999,
        }}
      >
        <CustomAlert
          id="toastr"
          onClose={handleSnackbarClose}
          severity={successOrError}
          icon={icon}
          message={toastrMessage}
        ></CustomAlert>
      </Snackbar>
    </Box>
  );
};

export default CustomSnackBar;